import { Map as FileMap } from './file';
import { Map as ApiMap  } from './api';

export class SchoolSoftMap {
  static to   = FileMap.to;
  static from = FileMap.from;

  static File = FileMap;
  static Api  = ApiMap;
}

export type { Types as SchoolSoftFileTypes } from './file';
export type { Types as SchoolSoftApiTypes } from './api';
